import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import fields, {
  columnName,
  columnLink,
  columnTarget,
  columnDescription,
  hasColumn,
} from '@/constants/fields';
import { findError } from '@/utils/errors';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import RowAddColumn from '@/components/table/RowAddColumn';
import { addVocabularyLink } from '../actions';

const VocabularyLinksTableColumns = ({
  columns = [columnName, columnLink, columnTarget],
  entity = 'link',
  errors,
  showEmptyRow,
}) => {
  const nameError = findError(errors, 'link', [fields.NAME]);
  const urlError = findError(errors, 'link', [fields.URL]);
  const targetError = findError(errors, 'link', [fields.TARGET]);
  const descriptionError = findError(errors, 'link', [fields.DESCRIPTION]);

  return (
    <Table.Row>
      {hasColumn(columns, columnName) && (<UnsortedColumn columnId="name" error={nameError} />)}
      {hasColumn(columns, columnLink) && (<UnsortedColumn columnId="url" error={urlError} />)}
      {hasColumn(columns, columnTarget) && (<UnsortedColumn columnId="target" error={targetError} />)}
      {hasColumn(columns, columnDescription) && (
      <UnsortedColumn columnId="description" error={descriptionError} />
      )}
      <RowAddColumn entity={`vocabulary.${entity}`} onClick={showEmptyRow} />
    </Table.Row>
  );
};

const mapDispatchToProps = {
  showEmptyRow: addVocabularyLink,
};

export default connect(null, mapDispatchToProps)(VocabularyLinksTableColumns);
